import { graphql } from 'gatsby';
import React from 'react';

import { BlogPostQuery } from '../../../../graphql-types';
import { TPageProps } from '../../../page-props';
import BlogPostPage from '../../../templates/blog-post';

export default (props: TPageProps<BlogPostQuery>) => <BlogPostPage {...props} />;

export const query = graphql`
  query BlogPost($uid: String, $lang: String) {
    prismicBlog(lang: { eq: $lang }) {
      data {
        related_blog_posts_label {
          text
        }
      }
    }
    allPrismicBlogPostTheme(filter: { lang: { eq: $lang } }) {
      ...PrismicBlogPostThemes
    }
    allPrismicAuthor {
      ...PrismicBlogPostAuthor
    }
    prismicBlogPost(uid: { eq: $uid }, lang: { eq: $lang }) {
      _previewable
      first_publication_date
      data {
        ...BlogPostData
      }
    }
  }
`;
